(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("react"), require("prop-types"), require("santa-core-utils"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "react", "prop-types", "santa-core-utils"], factory);
	else if(typeof exports === 'object')
		exports["santa-editor-symbols"] = factory(require("lodash"), require("react"), require("prop-types"), require("santa-core-utils"));
	else
		root["santa-editor-symbols"] = factory(root["lodash"], root["react"], root["prop-types"], root["santa-core-utils"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__6__) {
return 